import { memo, useEffect, useMemo } from 'react';

import { WorkspaceAgentComposerCreditsDepletedMessage } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/composer/WorkspaceAgentComposerCreditsDepletedMessage';
import { useWorkspaceAgentCreditsDepleted } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentCreditsDepleted';
import {
  getWorkspaceAgentCreditsDepletedBody,
  WORKSPACE_AGENT_CREDITS_DEPLETED_HEADING,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentCreditsDepletedMessageCopy';
import { useCreditStats } from '~/swr-hooks/workspaces/useCreditStats';

export type PrivateWorkspaceAgentPanelComposerCreditsDepletedMessageProps = {
  headingId?: string;
  trackViewOnMount?: boolean;
};

export const PrivateWorkspaceAgentPanelComposerCreditsDepletedMessage = memo(
  ({ headingId, trackViewOnMount = false }: PrivateWorkspaceAgentPanelComposerCreditsDepletedMessageProps) => {
    const { data: creditStats } = useCreditStats();
    const { canShowUpgradeCta, handleUpgradeClick, trackComposerDepletedViewed, upgradeCtaLabel } =
      useWorkspaceAgentCreditsDepleted();

    const body = useMemo(
      () =>
        getWorkspaceAgentCreditsDepletedBody({
          includeContactAdmin: !canShowUpgradeCta,
          nextCycleStartAt: creditStats?.nextCycleStartAt,
        }),
      [canShowUpgradeCta, creditStats?.nextCycleStartAt],
    );

    useEffect(() => {
      if (!trackViewOnMount) {
        return;
      }

      trackComposerDepletedViewed();
    }, [trackComposerDepletedViewed, trackViewOnMount]);

    return (
      <WorkspaceAgentComposerCreditsDepletedMessage
        body={body}
        heading={WORKSPACE_AGENT_CREDITS_DEPLETED_HEADING}
        headingId={headingId}
        onUpgradeClick={canShowUpgradeCta ? handleUpgradeClick : undefined}
        upgradeCtaLabel={canShowUpgradeCta ? upgradeCtaLabel : undefined}
      />
    );
  },
);

PrivateWorkspaceAgentPanelComposerCreditsDepletedMessage.displayName =
  'PrivateWorkspaceAgentPanelComposerCreditsDepletedMessage';
